import Axios from './axios'
import moment from 'moment'
import Constants from '@/constants'

export default {
  create: (serviceAreaId, jreToken, reservation) => {
    const axios = Axios.setup()
    // {
    //   "id": "1234567890",
    //   "serviceId": "G3M2",
    //   "operation": "create",
    //   "token": "266e7e09-37b9-49d2-96d9-78f5d782a84e",
    //   "reservationId": 12618,
    //   "estimatePickUpTime": "2020-12-25 20:16:02+09:00",
    //   "pickUpBusstopName": "ホテルビスタプレミオみなとみらい",
    //   "estimateDropOffTime": "2020-12-25T20:26:45+09:00",
    //   "dropOffBusstopName": "ホテルビスタプレミオみなとみらい",
    //   "savId": 12,
    //   "seatCountAdult": 2,
    //   "seatCountChild": 0,
    //   "serviceAreaIds": 208
    // }
    const data = {
      id: reservation.id,
      serviceId: Constants.API_ID,
      operation: "create",
      token: jreToken,
      reservationId: reservation.reservationId,
      reservationCode: reservation.reservationCode,
      estimatePickUpTime: moment(reservation.latestEstimatePickUpTime),
      pickUpBusstopName: reservation.pickUpBusstopName || reservation.pickUpLocationName,
      estimateDropOffTime: moment(reservation.latestEstimateDropOffTime),
      dropOffBusstopName: reservation.dropOffBusstopName || reservation.dropOffLocationName,
      savId: reservation.sav["savId"],
      seatCountAdult: reservation.seatCountDetail["adult"],
      seatCountChild: reservation.seatCountDetail["child"],
      serviceAreaIds: serviceAreaId
    }
    return new Promise((resolve,reject) => {
      axios.put(`user/reservation`, data)
          .then(() => {
            resolve()
          })
          .catch(error => {
            console.log(`middle create: ${error.response}`)
            reject(error)
          })
    })
  },
  cancel: (serviceAreaId, jreToken, reservation) => {
    const axios = Axios.setup()
    // {
    //   "id": "1234567890",
    //   "serviceId": "G3M2",
    //   "operation": "cancel",
    //   "token": "266e7e09-37b9-49d2-96d9-78f5d782a84e",
    // }
    const data = {
      id: reservation.id,
      serviceId: Constants.API_ID,
      operation: "cancel",
      token: jreToken
    }
    return new Promise((resolve,reject) => {
      axios.put(`user/reservation`, data)
          .then(() => {
            resolve()
          })
          .catch(error => {
            console.log(`middle cancel: ${error.response}`)
            reject(error)
          })
    })
  },
  information: (token) => {
    const axios = Axios.setup()
    return new Promise((resolve,reject) => {
      axios.get(`user/information?token=${token}`)
        .then((payload) => {
          const user = convert(payload.data)
          resolve(user)
        })
        .catch(error => {
          console.log(`middle information: ${error.response}`)
          reject(error)
        })
    })
  }
}

/*
 * Private functions
 */
function convert(data) {
  return {
    uuid: data.user.uuid,
    maebashi: data.user.maebashi,
    ticket: data.ticket
  }
}
